export const InspectionReportStatus = Object.freeze({
  NOT_STARTED: 'Not Started',
  STARTED: 'Started',
  READY_FOR_REVIEW: 'Ready for Review',
  COMPLETED: 'Completed',
  REJECTED: 'Rejected',
} as const);

export const InspectionStatusReversed = Object.freeze({
  [InspectionReportStatus.NOT_STARTED.toLowerCase()]: 'NOT_STARTED',
  [InspectionReportStatus.STARTED.toLowerCase()]: 'STARTED',
  [InspectionReportStatus.READY_FOR_REVIEW.toLowerCase()]: 'READY_FOR_REVIEW',
  [InspectionReportStatus.COMPLETED.toLowerCase()]: 'COMPLETED',
  [InspectionReportStatus.REJECTED.toLowerCase()]: 'REJECTED',
} as const);

export const PhotoResultStatus = Object.freeze({
  OK: 'OK',
  HAS_ISSUES: 'HAS_ISSUES',
  OVERRIDDEN: 'OVERRIDDEN',
  NA: 'NOT_APPLICABLE',
} as const);

export const VerificationCheck = Object.freeze({
  DATA_INTEGRITY: 'DATA_INTEGRITY',
  CAPTURE_INTEGRITY: 'CAPTURE_INTEGRITY',
  TIME_DATE: 'TIME_DATE',
  LOCATION: 'LOCATION',
  IMAGE_ANALYSIS: 'IMAGE_ANALYSIS',
  REVERSE_IMAGE_SEARCH: 'REVERSE_IMAGE_SEARCH',
});

export interface InspectionData {
  inspectionId: number;
  propertyAddress: string;
  latitude: number;
  longitude: number;
  allowedRadiusM: number;
}

export interface InspectionData {
  inspectionId: number;
  propertyAddress: string;
  latitude: number;
  longitude: number;
  allowedRadiusM: number;
}

export interface InspectionPhoto {
  inspectionPhotoId: number;
  inspectionPhotoUuid: string;
  inspectionTaskId: number;
  image: string;
  thumbnailImage: string;
  captureTimeIso: string;
  isHashValid: boolean;
  isSignatureValid: boolean;
  isLocationValid: boolean;
  isLocationValidManualOverride: boolean;
  locationData: {
    latitude: number;
    longitude: number;
    timestampISO: string;
    accuracy: number;
    altitudeAccuracy: number;
    altitude: number;
    speed: number;
    heading: number;
  };
  deviceData: {
    deviceId: string;
    deviceModel: string;
    platform: string;
    osVersion: string;
    appVersion: string;
    userAgent: string;
    screenResolution: string;
    locale: string;
    timestampISO: string;
  };
  preferredRotation: number;
  caption: string;
  reported: boolean;
  // 'MOBILE' | 'DESKTOP'. Used as a defensive, per-photo check (in addition to the
  // inspection-level activeRealValPhotoSource) so metadata/validation UI never shows for a
  // manually-uploaded photo even if the activeRealValPhotoSource lookup fails.
  source?: string;
}

export interface InspectionDetails {
  inspectionId: number;
  inspectionStatus: keyof typeof InspectionReportStatus | null;
  drawId: number;
  propertyAddress: string;
  contactOnLoan: string;
  latitude: number;
  longitude: number;
  allowedRadiusM: number;
  lastUpdatedDate: Date;
  externalId1: string;
  externalId2: string;
  inspectionType?: string;
  photoSource?: string;
  photoSourceOther?: string;
  photosTakenDate?: string;
}

export interface InspectionTask {
  inspectionTaskId: number;
  inspectionId: number;
  inspectionTaskTemplateId: number;
  taskType: string;
  title: string;
  description: string;
  sortOrder: number;
  comments: string;
  lastUpdatedDate: Date;
}

export enum InspectionsDashboardTabs {
  INSPECTIONS_DRAWS = 'draws',
  INSPECTIONS_INTERNAL_VALUATIONS = 'internal-valuations',
  INSPECTIONS_AUCTION_PROPERTIES = 'auction-properties',
  MEDIA_LIBRARY = 'media-library',
}

export interface InspectionGridItemResponse {
  inspectionId: number;
  drawId: string;
  loanId: string;
  inspectionStatus: string;
  propertyAddress: string;
  successPhotosCount: number;
  failedPhotosCount: number;
  createdDate: string;
  lastUpdatedDate: string;
}

export interface PaginatedInspectionsResponse {
  status: string;
  data: {
    totalCount: number;
    rows: InspectionGridItemResponse[];
  };
}
